<script>
  import { writable } from "svelte/store";
  import { onMount } from "svelte";
  import { HStack, VStack, Spacer, Fixed, MediaQuery } from "./layout";
  import { Padding } from "./modifier";
  import { Button, Icon, Label } from "./widget";
  import { navigate } from "../router";
  import { refresh_count } from "../guest.js";

  export let guid;

  let guests_count = writable({
    total: {
      attending: 0,
      count: 0,
    },
    adult: {
      attending: 0,
      count: 0,
    },
    teen: {
      attending: 0,
      count: 0,
    },
    child: {
      attending: 0,
      count: 0,
    },
    baby: {
      attending: 0,
      count: 0,
    },
  });

  const doit = () => navigate(`#/guests/${guid}`);

  onMount(() => {
    refresh_count(guid).then((r) => guests_count.set(r));
  });
</script>

<article>
  <MediaQuery query="(min-width: 481px)">
    <VStack alignment="center">
      <img src="/images/invites.svg" alt="guests" width="48px" />
      <p>
        Invités présents&nbsp;:
        <span>{`${$guests_count.total.attending} / ${$guests_count.total.count}`}</span>
      </p>
      {#if $guests_count.total.count > 0}
        <VStack>
          <Padding top="0">
            <HStack alignment="center">
              <Label
                text={`${$guests_count.adult.attending} / ${$guests_count.adult.count} Adulte(s)`}
                icon="restroom" />
            </HStack>
          </Padding>
          <Padding top="0">
            <HStack alignment="center">
              <Label
                text={`${$guests_count.teen.attending} / ${$guests_count.teen.count} Ado(s)`}
                fa={false}
                icon="images/cap.svg" />
            </HStack>
          </Padding>
          <Padding top="0">
            <HStack alignment="center">
              <Label
                text={`${$guests_count.child.attending} / ${$guests_count.child.count} Enfant(s)`}
                icon="child" />
            </HStack>
          </Padding>
          <Padding top="0">
            <HStack alignment="center">
              <Label
                text={`${$guests_count.baby.attending} / ${$guests_count.baby.count} Bébé(s)`}
                icon="baby" />
            </HStack>
          </Padding>
        </VStack>
      {/if}

      <button class="primary" on:click={doit}>Modifier</button>
    </VStack>
  </MediaQuery>
  <MediaQuery query="(max-width: 480px)">
    <Button action={doit}>
      <HStack alignment="center">
        <img src="/images/invites.svg" alt="guests" width="48px" />
        <span>Liste d'invités</span>
        <Spacer />
        <Icon name="chevron-right" />
        <Fixed />
      </HStack>
    </Button>
  </MediaQuery>
</article>

<style>
  article {
    width: 100%;
    min-height: 48px;
    background-color: white;
    margin-top: 5px;
    padding-top: 5px;
  }
  span {
    margin-left: 1em;
  }
  @media (min-width: 481px) {
    article {
      padding: 1em;
      width: fit-content;
      min-width: 150px;
    }
    span {
      margin-left: 0;
    }
  }
</style>
